export const MODULE_ID = "VirtoCommerce.BackInStock";
export const ENABLED_KEY = "BackInStock.Enable";
